import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import HoverActionButtonsCell from '@/components/table/HoverActionButtonsCell';
import { editDataset } from '../../actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldValue = ({
  canEdit,
  canRead,
  category,
  code,
  colSpan,
  copyToClipboard,
  disabled,
  href,
  link,
  onClick,
  showEdit,
  showUrlLinks,
  template,
  title,
  value,
}) => (
  <HoverActionButtonsCell
    canEdit={canEdit}
    canRead={canRead}
    colSpan={colSpan}
    content={value}
    copyToClipboard={copyToClipboard}
    disabled={disabled}
    exists
    href={href}
    link={link}
    onClick={onClick}
    showEdit={() => showEdit(category, code, template)}
    showUrlLinks={showUrlLinks}
    title={title}
  />
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps);

  return (
    {
      template,
      disabled: !dataset
            || dataset.uploadStatus === states.PENDING
            || dataset.attachments.uploadStatus === states.PENDING,
    }
  );
};

const mapDispatchToProps = {
  showEdit: editDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldValue);
